import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/fontawesome-free-solid';

class CloseLink extends React.Component {
  render() {
    return (
      <Link to={this.props.to} className="">
        <FontAwesomeIcon icon={faTimes} />
      </Link>
    );
  }
}
CloseLink.defaultProps = {
  to: '/',
};

export default CloseLink;

export function CardTitle(props) {
  return (
    <div className={`d-flex w-100 justify-content-between ${props.className || 'mb-3'}`}>
      <h5 className="card-title">{props.title}</h5>
      {props.children}
    </div>
  );
}
export function CardHeader(props) {
  return (
    <CardTitle {...props}>
      <CloseLink />
    </CardTitle>
  );
}

export function Card(props) {
  return (
    <div className="card mb-3">
      <h5 className="card-header">{props.header}</h5>
      <div className="list-group list-group-flush">{props.children}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Card.js